import { useToast } from '@chakra-ui/react'
import dayjs from 'dayjs'
import { FormEvent, useState } from 'react'
import writeXlsxFile, { Row, SheetData } from 'write-excel-file'
import { get } from '../../../lib/http'
import extractDataForm from '../../../utilities/extractDataForm'

import { DataForm, ReportSalesBySegment } from './types'

export default function usePrintSalesBySegment() {
    const toast = useToast()
    const [isLoading, setIsLoading] = useState(false)

    const head: (...values: string[]) => Row[number][] = (...values) =>
        values.map<Row[number]>(val => ({
            value: val,
            fontWeight: 'bold',
            wrap: true,
            alignVertical: 'center',
            align: 'left',
            fontSize: 11
        }))

    function setSalesBySegment(data: ReportSalesBySegment[], rows: SheetData) {
        data.forEach(item => {
            rows.push([
                {
                    value: item.date,
                    type: String
                },
                {
                    value: item.code_receipt,
                    type: String
                },
                {
                    value: item.category,
                    type: String
                },
                {
                    value: item.product,
                    type: String
                },
                {
                    value: item.comment_order,
                    type: String
                },
                {
                    value: item.reason_courtesy,
                    type: String
                },
                {
                    value: item.is_courtesy,
                    type: String
                },
                {
                    value: item.quantity,
                    type: Number
                },
                {
                    value: item.price,
                    type: Number,
                    align: 'right',
                    format: '#,##0.00'
                },
                {
                    value: item.sale_amount,
                    type: Number,
                    align: 'right',
                    format: '#,##0.00'
                },
                {
                    value: item.waiter_name,
                    type: String
                },
                {
                    value: item.segment,
                    type: String
                },
                {
                    value: item.agency_or_local_guide,
                    type: String
                }
            ])
        })
    }

    async function submit(ev: FormEvent<HTMLFormElement>) {
        ev.preventDefault()
        const form = extractDataForm<DataForm>(ev.target)
        const startDate = dayjs
            .tz(form.startDate + ' 00:00:00', 'America/Lima')
            .toISOString()
        const endDate = dayjs
            .tz(form.endDate + ' 23:59:59', 'America/Lima')
            .toISOString()

        const rows: SheetData = [
            [],
            [
                {
                    value: 'Reporte de Ventas Detallada por Segmento',
                    fontWeight: 'bold',
                    span: 13,
                    alignVertical: 'center',
                    align: 'center',
                    fontSize: 16
                }
            ],
            [
                {
                    value: `De: ${dayjs(startDate).format(
                        'DD/MM/YYYY'
                    )} - Hasta ${dayjs(endDate).format('DD/MM/YYYY')}`,
                    span: 13,
                    align: 'center'
                }
            ],
            [],
            head(
                ...[
                    'Fecha y Hora',
                    'Comprobante',
                    'Categoría',
                    'Producto',
                    'Observación',
                    'Motivo de Cortesía',
                    '¿Es Cortesía?',
                    'Cantidad',
                    'Precio (S/)',
                    'Venta (S/)',
                    'Meser@',
                    'Segmento',
                    'Cliente'
                ]
            )
        ]

        setIsLoading(true)

        const { data, error } = await get<ReportSalesBySegment[]>(
            `/api/reports/sales_by_segment?start_date=${startDate}&end_date=${endDate}`
        )

        if (error) {
            toast({
                title: 'Hubo un error al cargar los datos',
                status: 'error',
                position: 'top'
            })
            return
        }

        setSalesBySegment(data.result, rows)

        await writeXlsxFile(rows, {
            fileName: `Reporte_de_ventas_detallada_por_segmento_${dayjs(
                startDate
            ).format('DD/MM/YYYY')}_${dayjs(endDate).format(
                'DD/MM/YYYY'
            )}.xlsx`,
            columns: [25, 15, 25, 30, 25, 25, 15, 15, 20, 20, 25, 25, 25].map(
                width => ({
                    width
                })
            ),
            fontSize: 10,
            fontFamily: 'Calibri'
        })

        setIsLoading(false)
    }

    return {
        submit,
        isLoading
    }
}
